import Modal, {ModalProps} from 'react-bootstrap/Modal';
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useTranslation} from "react-i18next";
import {toast} from "react-custom-alert";
import SubscriptionFormEdit from '../forms/SubscriptionFormEdit';

const EditSubscription = ({ subscriptionData, customToken, ...props }: ModalProps)  => {
    const { t } = useTranslation();
    const{getAppUniqueToken} = useAppUniqueToken();
    const [uaToken, setUaToken] = useState(getAppUniqueToken);
    const [updatedSubscriptionData, setUpdatedSubscriptionData] = useState({});

    const handleConfirm = () => {
        const payload = {
            id: subscriptionData.id,
            uaToken,
            ...updatedSubscriptionData
        };

        axios.post('api/update-subscription', payload)
            .then((response) => {
                // if (response.data?.message) {
                //     toast.success(response.data.message);
                // } else {
                //     toast.success(t('messages.saveSuccess'));
                // }

                props.onHide?.();
                location.reload();
            })
            .catch((error) => {
                toast.error(error.response?.data?.error ?? t('messages.defaultErrorMessage'));
            });
    };



    useEffect(() => {
        if(customToken)
            setUaToken(customToken);
    }, [customToken])

    return (

        <Modal
            {...props}
            centered
            backdrop="static"
            keyboard={false}
            size='lg'
        >
            <Modal.Body>
                <h4>{t('captions.editSubscription')}</h4> <br />
                <SubscriptionFormEdit 
                    data={subscriptionData}
                    // submitForm={handleConfirm}
                    onChangeForm={setUpdatedSubscriptionData}

                    
                />
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn_1 green" onClick={handleConfirm}>{t('captions.confirm')}</button>
                <button type="button" className="btn_1 yellow" onClick={props.onHide}>{t('captions.cancel')}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditSubscription;
